module.exports = __webpack_public_path__ + "static/media/p-dp.dec60af6.png";